import { useMutation } from '@tanstack/react-query';
import { produce } from 'immer';

import { useSnackbar } from '@/features/snackbar';
import useWatchlistQueryClient from '@/pages/Watchlist/hooks/useWatchlistQueryClient';

import { queryFn } from './queryFn';

type Payload = {
  fairValue: number;
};

type Args = {
  companyId: string;
  watchlistId: string;
  onSuccess?(data: Awaited<ReturnType<typeof queryFn>>): void;
};

export function useWatchlistAddFairValue({
  onSuccess,
  companyId,
  watchlistId,
}: Args) {
  const { addSnackbar } = useSnackbar();
  const watchlistQueryClient = useWatchlistQueryClient();

  const mutation = useMutation({
    mutationFn: (payload: Payload) =>
      queryFn({ companyId, watchlistId, ...payload }),
    onSuccess(data) {
      watchlistQueryClient.setQueriesData(watchlistId, (state) =>
        produce(state, (draft) => {
          draft.items.map((item) => {
            if (item.id === data.id) {
              return data;
            }
            return item;
          });
        })
      );
      addSnackbar({
        message: 'Fair value set',
        type: 'positive',
        lifeTime: 3000,
      });
      onSuccess?.(data);
    },
    onSettled() {
      watchlistQueryClient.invalidateQueries(watchlistId);
    },
  });

  return mutation;
}
